// Updates page title in <head>
class MetaService {
  updateMeta(payload) {
    document.title = `${process.env.VUE_APP_SITE_TITLE} – ${payload.title}`
  }
}

export default new MetaService()
